import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const money = (value) => `$ ${Number(value || 0).toFixed(2)}`;

export const generarOrdenCompraPDF = (orden) => {
  if (!orden) return;

  const doc = new jsPDF();
  const resumen = orden.resumen || {
    total_guardado: Number(orden.total_orden || 0),
    total_productos: 0,
    total_libraje_quemado: 0,
    total_real: 0,
  };

  const formatDate = (value) => (value ? new Date(value).toLocaleString() : '-');

  doc.setFontSize(18);
  doc.text(`Detalle de Orden de Compra #${orden.id}`, 14, 18);
  doc.setFontSize(11);

  autoTable(doc, {
    startY: 24,
    body: [
      ['Codigo', orden.codigo || '-'],
      ['Proveedor', orden.proveedor_nombre || '-'],
      ['Fecha', formatDate(orden.fecha)],
      ['Estado', orden.estado || '-'],
      ['Total guardado', money(resumen.total_guardado)],
      ['Total productos', money(resumen.total_productos)],
      ['Total libraje quemado', money(resumen.total_libraje_quemado)],
      ['Total real', money(resumen.total_real)],
    ],
    theme: 'plain',
    styles: { fontSize: 10, cellPadding: 1.5 },
    columnStyles: { 0: { fontStyle: 'bold', cellWidth: 58 } },
  });

  const body = (orden.lineas || []).map((linea) => [
    linea.detalle_id || linea.id,
    linea.nombre || linea.producto?.nombre || `ID ${linea.producto_id || ''}`,
    linea.cantidad,
    money(linea.subtotal),
    money(linea.libraje_quemado),
    money(linea.libraje_producto),
    money(linea.libraje_usado),
    money(linea.libraje_linea),
    money(linea.total_linea),
  ]);

  const startY = (doc.lastAutoTable?.finalY || 50) + 8;

  autoTable(doc, {
    startY,
    head: [[
      'ID',
      'Producto',
      'Cantidad',
      'Subtotal',
      'Libraje quemado',
      'Libraje producto',
      'Libraje usado',
      'Libraje linea',
      'Total linea',
    ]],
    body,
    theme: 'grid',
    headStyles: { fillColor: [33, 150, 243], textColor: 255 },
    styles: { fontSize: 9 },
  });

  const endY = (doc.lastAutoTable?.finalY || startY) + 10;
  doc.setFontSize(12);
  doc.text(`Total real: ${money(resumen.total_real)}`, 14, endY);

  doc.save(`orden_compra_${orden.codigo || orden.id}.pdf`);
};
